// extracted by mini-css-extract-plugin
module.exports = {"atendimentoConsulta":"Consultar_atendimentoConsulta__2l5GN","containerPainel":"Consultar_containerPainel__ZvWd7"};